import { definitions as definitions1, } from "./1/tokens";
import { definitions as definitions18, } from "./18/tokens";
import { definitions as definitions188, } from "./188/tokens";

import { definitions as definitions42161, } from "./42161/tokens";
import { definitions as definitions421618, } from "./421618/tokens";
import { definitions as definitions4216188, } from "./4216188/tokens";

import type { TokenDefinition } from "./types";

export const definitions = [].concat(
	definitions1,
	definitions18,
	definitions188,
	definitions42161,
	definitions421618,
	definitions4216188,
) as TokenDefinition[];
